export default "__VITE_ASSET__586cb099__"